// @flow

import * as React from 'react';
import { withRouter } from 'react-router';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { Box, Text } from 'grommet';
import styled from 'styled-components';
import permissionRequired from 'esm-web-pro/decorators/permissionRequired';
import type { Entity } from 'esm-web-pro/types/entities';
import { FormattedMessage } from 'react-intl';

const NavLink = styled(RouterNavLink)`
    text-decoration: none;
    color: ${(props) => props.theme.global.colors.text.dark};
`;

const StyledBox = styled(Box)`
    &:hover {
        background-color: white;
    }
`;

type Props = {
    project: Entity,
};

const StyledNavLink = (props: { path: string, name: React.Node, permissions: Array<string> }) => {
    const { path, name, permissions } = props;

    const NavLinkComponent = () => (
        <NavLink
            to={path}
            activeStyle={{
                backgroundColor: 'white',
            }}
        >
            <StyledBox pad={{ vertical: 'small', horizontal: 'medium' }} hoverIndicator="light-1">
                <Text size="medium" weight={600}>
                    {name}
                </Text>
            </StyledBox>
        </NavLink>
    );

    const PermissionsRequiredNavLink = permissionRequired(permissions || [])(NavLinkComponent);

    return (
        <PermissionsRequiredNavLink {...props} />
    );
};

const ProjectTabs = (props: Props) => {
    const { project } = props;
    return (
        <Box margin={{ top: '10px' }}>
            <StyledNavLink
                path={`/projects/${project.uuid}/dashboard/stages`}
                name={(
                    <FormattedMessage id="project-tabs-stages" defaultMessage="Stages" />
                )}
                permissions={['project.view_stage']}
            />
            {/* TODO: Currently this is not implemented
            <StyledNavLink
                path={`/projects/${project.uuid}/dashboard/documents`}
                name={(
                    <FormattedMessage id="project-tabs-documents" defaultMessage="Documents" />
                )}
                permissions={['documents.view_document']}
            /> */}
            <StyledNavLink
                path={`/projects/${project.uuid}/dashboard/gis-points`}
                name={(
                    <FormattedMessage id="project-tabs-map-objects" defaultMessage="Map Objects" />
                )}
                permissions={['networks.view_pointlayer1_1']}
            />
        </Box>
    );
};

export default withRouter(ProjectTabs);
